module.exports = __webpack_public_path__ + "img/1-5.8ba53940.svg";